import React from "react";
import Property from "./Property";
import {Collapse, Row} from 'antd';
import {CaretRightOutlined} from '@ant-design/icons';
import './TownHouse.less';

const {Panel} = Collapse;

const Bedroom = (props) => {

	return (
		<div className={'level'}>
			<Collapse
				bordered={false}
				defaultActiveKey={false}
				expandIcon={({isActive}) => <CaretRightOutlined rotate={isActive ? 90 : 0}/>}
				className="site-collapse-custom-collapse"
			>
				<Panel header={props.data.bedroom} key={`${props.appName}-${props.index}`} className="site-collapse-custom-panel">
					<Row gutter={[16, 10]}>
						{props.data.types.map((type, index) => type.apartments.map((apt, idx) => <Property key={`${index}-${idx}`} data={apt} status={props.status} statusChange={props.statusChange} dataType={props.dataType}/>))}
					</Row>
				</Panel>
			</Collapse>
		</div>
	);
};

export default Bedroom;